export const APP_NAME = 'EdyTech Smart Board Repairs';
export const APP_DESCRIPTION = 'Professional Device Repairs, Online Training & Genuine Gadgets';
export const SUPPORTED_DEVICE_TYPES = [
    'smartphone',
    'laptop',
    'tablet',
    'smartboard',
    'console',
    'other'
];
export const REPAIR_STATUSES = [
    'SUBMITTED',
    'IN_PROGRESS',
    'WAITING_PARTS',
    'COMPLETED',
    'DELIVERED',
    'CLOSED'
];
/* ============================ LIVE CLASSES (Module 5) ============================ */
// Roles
export const USER_ROLES = ['customer', 'student', 'instructor', 'admin', 'technician'];
// Live class entity statuses
export const LIVE_CLASS_STATUSES = ['DRAFT', 'PUBLISHED', 'ARCHIVED'];
export const LIVE_CLASS_SESSION_STATUSES = ['SCHEDULED', 'ONGOING', 'ENDED', 'CANCELLED'];
export const REGISTRATION_STATUSES = ['REGISTERED', 'CANCELLED'];
export const REGISTRATION_SOURCES = ['SELF', 'ADMIN', 'BULK'];
export const ATTENDANCE_STATUSES = ['NOT_RECORDED', 'PRESENT', 'LATE', 'PARTIAL', 'ABSENT'];
export const ATTENDANCE_SOURCES = ['SYSTEM', 'INSTRUCTOR'];
export const MESSAGE_TYPES = ['CHAT', 'QUESTION', 'ANSWER', 'ANNOUNCEMENT', 'POLL'];
export const RECORDING_STATUSES = ['NONE', 'RECORDING', 'PROCESSING', 'READY', 'FAILED'];
export const TRANSCRIPT_STATUSES = ['NONE', 'PROCESSING', 'READY', 'FAILED'];
export const MEETING_PROVIDERS = ['AGORA', 'DAILY'];
export const EMAIL_OUTBOX_STATUSES = ['PENDING', 'SENT', 'FAILED', 'SKIPPED'];
export const PROVIDER_EVENT_STATUSES = ['RECEIVED', 'PROCESSED', 'FAILED'];
// Email templates (outbox `template` column)
export const EMAIL_TEMPLATES = [
    'LIVE_CLASS_REGISTRATION',
    'LIVE_CLASS_REMINDER_24H',
    'LIVE_CLASS_REMINDER_1H',
    'LIVE_CLASS_STARTED',
    'LIVE_CLASS_CANCELLED',
    'LIVE_CLASS_AUTO_ENDED',
    'RECORDING_AVAILABLE',
    'ATTENDANCE_SUMMARY',
    'NO_SHOW_FOLLOW_UP',
];
/* ============================ ADMIN DASHBOARD ============================ */
// Global analytics date-range filter buckets (in days). The admin dashboard
// uses these to window every KPI, revenue and chart aggregation server-side.
export const DASHBOARD_RANGES = [7, 14, 30, 90];
// Order statuses that count toward revenue (excludes PENDING/CANCELLED/REFUNDED).
export const REVENUE_ORDER_STATUSES = ['PAID', 'PROCESSING', 'SHIPPED', 'DELIVERED'];
// Repair statuses that count as "pending / in progress" on the dashboard.
export const PENDING_REPAIR_STATUSES = ['SUBMITTED', 'IN_PROGRESS', 'WAITING_PARTS'];
export const COMPLETED_REPAIR_STATUSES = ['COMPLETED', 'DELIVERED'];
// Reminder templates (used by the 15-min cron scheduler)
export const REMINDER_TEMPLATES = {
    TWENTY_FOUR_HOURS: 'LIVE_CLASS_REMINDER_24H',
    ONE_HOUR: 'LIVE_CLASS_REMINDER_1H',
};
// Business rules
export const REGISTRATION_LOCK_MINUTES = 30; // registration lock at startsAt - 30min
export const REGISTRATION_LOCK_MS = REGISTRATION_LOCK_MINUTES * 60 * 1000;
export const ATTENDANCE_DEFAULT_RULE = { thresholdPct: 80, lateGraceMin: 10 };
/* ---- Streaming / in-session (Phase 2, TRD §4.2/§6.3/§6.5/§6.6) ---- */
// Logical join role inside the room (mirrors `role` on JoinTokenResponse).
export const JOIN_ROLES = ['host', 'audience'];
// Class mode: interactive (everyone publishes) vs broadcast (>threshold registrants).
export const JOIN_MODES = ['broadcast', 'interactive'];
// Join window (TRD §4.2): startsAt - 15min <= now <= endsAt + 30min (±5min clock-skew tolerance).
export const JOIN_WINDOW_BEFORE_MIN = 15;
export const JOIN_WINDOW_AFTER_MIN = 30;
export const JOIN_WINDOW_BEFORE_MS = JOIN_WINDOW_BEFORE_MIN * 60 * 1000;
export const JOIN_WINDOW_AFTER_MS = JOIN_WINDOW_AFTER_MIN * 60 * 1000;
// RTC token validity: privilege expires at endsAt + buffer (TRD §6.3: +2h).
export const TOKEN_EXPIRY_BUFFER_MIN = 120;
export const TOKEN_EXPIRY_BUFFER_MS = TOKEN_EXPIRY_BUFFER_MIN * 60 * 1000;
// Client refreshes its join-token before `expiresAt - TOKEN_REFRESH_BEFORE_MS` (TRD §6.6).
export const TOKEN_REFRESH_BEFORE_MS = 10 * 60 * 1000; // 10 minutes
// Broadcast (live-stream) mode kicks in when registered attendees exceed this (TRD §6.5: >500).
export const BROADCAST_THRESHOLD_REGISTRANTS = 500;
// Recording key prefix for a session (TRD §7.2) — R2 prefix `live/{sessionId}/recording/`.
export const RECORDING_KEY_PREFIX = (sessionId) => `live/${sessionId}/recording/`;
/* ---- Real-time chat & Q&A (Phase 3, TRD §4.3/§4.4/§6.5) ---- */
// Per-connection WS message token bucket refill rate (TRD §4.3 backpressure).
export const WS_MAX_MESSAGES_PER_SEC = 5;
// Max length of a chat / question / poll-question message (TRD §4.3).
export const WS_MAX_MESSAGE_LENGTH = 1000;
// Client heartbeat cadence (TRD §4.3: heartbeats every 60s, presence only).
export const WS_HEARTBEAT_INTERVAL_MS = 60000;
// DO fan-out cap (TRD §4.4: >500 → degraded mode, REST fallback).
export const WS_MAX_CONNECTIONS = 500;
// History keyset pagination defaults (TRD §4.2 `GET messages`).
export const MESSAGE_HISTORY_LIMIT_DEFAULT = 50;
export const MESSAGE_HISTORY_LIMIT_MAX = 200;
// Client reconnect backoff bounds (TRD §6.6 network flakiness).
export const WS_RECONNECT_BACKOFF_MIN_MS = 1000;
export const WS_RECONNECT_BACKOFF_MAX_MS = 30000;
// Degraded (REST fallback) polling interval.
export const DEGRADED_POLL_INTERVAL_MS = 5000;
